import React, { useContext, useState } from 'react'
import { InputBoxWraper, Loader } from '../../constents/components'
import uploadIcon from '../../Assets/uploadIconBlack.svg';
import { SmallSignUpContext } from '../../Contexts/smallSignUpContext';
import useSignupFromLinkedin from '../../Hooks/Auth/useSignupFromLinkedin';
import crossIcon from '../../Assets/closeIcon.svg';
import { useNavigate } from 'react-router-dom';
import { RedirectUrlGetter } from '../../Utils/functions';
import useRedirect from '../../Hooks/Auth/useRedirect';
import { CITY_LIST, EDUCATION_LIST } from '../../constants/list';




const Sucess = () => {
    return (
        <div className=' flex flex-col items-center justify-center h-full gap-4 p-4'>
            <h4 className=' font-semibold text-2xl text-center'>You’ve successfully applied for this job! 🎉</h4>
            <p className=' text-text-color-strong text-center'>We’ve sent a verification link to your email. Please confirm it to set your password and follow your application updates.</p>
        </div>
    )
}

const ErrorMessage = ({ message , closePopUp }) => {
    const { redirectUrlSetter} = useRedirect();
    const navigate = useNavigate();
    const handleClick = () =>{
        closePopUp();
        redirectUrlSetter();
        navigate('auth/login');
    }
    return (
        <div className=' flex flex-col items-center justify-center p-8'>
            <p className=' text-xl text-black font-semibold'>You already have an account with us</p>
            <p>Please <span className='text-blue-500 font-semibold hover:underline cursor-pointer'
                // onClick={() => {window.open('/auth/login', '_self') } }
                onClick={handleClick}
            >Login</span> to continue.</p>
        </div>
    )
}

const SmallSignUp = () => {

    const { jobId, closePopUp } = useContext(SmallSignUpContext);
    const [loading, error, signUpFunction] = useSignupFromLinkedin();
    const [success, setSuccess] = useState(false);

    const [states, setStates] = useState({
        email: '',
        firstName: '',
        lastName: '',
        linkedin: '',
        resume: null,
        mobile: '',
        education: '',
        current_ctc: '',
        expected_ctc: '',
        years_of_experience: '',
        city: '',
    });

    const [openDropdown, setOpenDropdown] = useState(null);
    const [formError, setFormError] = useState({
        email: '',
        firstName: '',
        lastName: '',
        linkedin: '',
        resume: '',
        mobile: '',
        education: '',
        current_ctc: '',
        expected_ctc: '',
        years_of_experience: '',
        city: ''
    });

    const placeHolder = {
        email: 'Johndoe@abc.com',
        firstName: 'John',
        lastName: 'Doe',
        linkedin: '',
        mobile: '88xxxxxxxx',
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setStates((prev) => ({ ...prev, [name]: value }));
    };



    const handleSubmit = async (e) => {
        e.preventDefault();
        // Handle form submission logic here
        const errors = {
            email: '',
            firstName: '',
            lastName: '',
            linkedin: '',
            resume: '',
            mobile: '',
            education: '',
            current_ctc: '',
            expected_ctc: '',
            years_of_experience: '',
            city: ''
        };

        let hasError = false;
        if (!states.resume) {
            errors.resume = 'Resume is required';
            hasError = true;
        }
        if (!states.email) {
            errors.email = 'Email is required';
            hasError = true;
        }
        if (!states.firstName) {
            errors.firstName = 'First name is required';
            hasError = true;
        }
        if (!states.lastName) {
            errors.lastName = 'Last name is required';
            hasError = true;
        }
        if (!states.mobile) {
            errors.mobile = 'Mobile number is required';
            hasError = true;
        }
        if (!states.education) {
            errors.education = 'Education is required';
            hasError = true;
        }

        if (!states.current_ctc) {
            errors.current_ctc = 'Current CTC is required';
            hasError = true;
        }

        if (!states.expected_ctc) {
            errors.expected_ctc = 'Expected CTC is required';
            hasError = true;
        }

        if (
            states.years_of_experience === '' ||
            states.years_of_experience === null ||
            states.years_of_experience === undefined
        ) {
            errors.years_of_experience = 'Years of experience is required';
            hasError = true;
        }

        if (!states.city) {
            errors.city = 'City is required';
            hasError = true;
        }
        setFormError(errors);
        if (hasError) return;

        try {
            // await signUpFunction(states);
            const formData = new FormData();
            formData.append('email', states.email);
            formData.append('firstname', states.firstName);
            formData.append('lastname', states.lastName);
            formData.append('linkedinUrl', states.linkedin);
            formData.append('phone', states.mobile);
            formData.append('resume', states.resume);
            formData.append('jobId', jobId);
            formData.append('education', states.education);
            formData.append('current_ctc', states.current_ctc);
            formData.append('expected_ctc', states.expected_ctc);
            formData.append('years_of_experience', states.years_of_experience);
            formData.append('city', states.city);

            await signUpFunction(formData);
            setSuccess(true);

        } catch (err) {
            // Handle error
        }

    };

    return (
        <div className=' fixed top-0 right-0 left-0 bottom-0 flex items-start gap-4 flex-row-reverse justify-center p-4 lg:p-8 bg-popup-bg-color backdrop-blur-[5px] z-[--after-registration-popup]'>
            <img src={crossIcon} alt="Close" className=" -mt-2 cursor-pointer w-8" onClick={closePopUp} />
            <div className=' border bg-white w-full md:w-4/5 lg:w-2/5 rounded-xl flex flex-col items-center min-h-[40vh] max-h-full overflow-auto'>
                {success ? <Sucess /> : loading ? (<Loader />) : error ? (<>
                    {error === 'User already registered' ? <ErrorMessage message={error} closePopUp={closePopUp} /> : <p className='p-4'>{error}</p>}
                </>) :
                    (<div className=' w-full p-4 flex flex-col gap-6'>
                        <h4 className='font-semibold text-2xl text-center'>Join application</h4>
                        <div>
                            <label className="block font-semibold mb-1 text-sm ">Upload your resume</label>
                            <div className=' border-2 border-dashed border-orange-500 rounded-lg p-6 text-center flex flex-col items-center'>
                                <div
                                    className='rounded-lg p-2 mt-4 flex flex-col items-center'
                                // onChange={(e) => !mockResumeLoading && !mockInterviewId && mockResumeUploader(e.target.files[0])}
                                >
                                    <input
                                        type="file"
                                        multiple="multiple"
                                        id="talentUploadButtonLabel"
                                        className="hidden"
                                        accept=".pdf,.docx"
                                        onChange={(e) => setStates((prev) => ({ ...prev, resume: e.target.files[0] }))}
                                    />
                                    <label
                                        htmlFor="talentUploadButtonLabel"
                                        className="flex cursor-pointer w-full flex-col items-center"
                                    >
                                        <div className="w-12 h-12 flex items-center justify-center bg-gray-200 rounded-full ">
                                            <img src={uploadIcon} className="w-6 h-6" alt="uploadIcon" />
                                        </div>
                                        <div className="text-center">
                                            <p className="text-gray-500 text-sm mt-2">.pdf or .docx</p>
                                        </div>
                                    </label>
                                </div>
                            </div>
                            {states?.resume?.name ? <h6 className='text-primary-color-900 text-sm mt-1'>{states.resume.name}</h6> : formError?.resume && <h6 className='text-primary-color-900 text-sm mt-1'>{formError.resume}</h6>}
                        </div>
                        <div>
                            <h4 className=' text-sm font-semibold'>Email*</h4>
                            <InputBoxWraper >
                                <input
                                    className='outline-none w-full bg-transparent'
                                    type='email'
                                    placeholder='Email'
                                    value={states.email}
                                    name='email'
                                    onChange={handleChange}
                                    required
                                />
                            </InputBoxWraper>
                            {formError?.email && <h6 className='text-primary-color-900 text-sm mt-1'>{formError.email}</h6>}
                        </div>
                        <div className=' flex gap-2 '>
                            <div className={'flex-1'} >
                                <h4 className=' text-sm font-semibold'>First name*</h4>
                                <InputBoxWraper >
                                    <input
                                        type="text"
                                        className=" w-full bg-transparent outline-none border-none"
                                        placeholder={placeHolder.firstName}
                                        value={states.firstName}
                                        onChange={handleChange}
                                        name="firstName"
                                        required
                                    />
                                </InputBoxWraper>
                                {formError?.firstName && <h6 className='text-primary-color-900 text-sm mt-1'>{formError.firstName}</h6>}
                            </div>
                            <div className={'flex-1'} >
                                <h4 className=' text-sm font-semibold'>Last name*</h4>
                                <InputBoxWraper classnames={'flex-1'} >
                                    <input
                                        type="text"
                                        className=" w-full bg-transparent outline-none border-none"
                                        placeholder={placeHolder.lastName}
                                        value={states.lastName}
                                        onChange={handleChange}
                                        name="lastName"
                                        required
                                    />
                                </InputBoxWraper>
                                {formError?.lastName && <h6 className='text-primary-color-900 text-sm mt-1'>{formError.lastName}</h6>}
                            </div>
                        </div>

                        <div>
                            <h4 className='text-sm font-semibold mb-1'>
                                Education*
                            </h4>

                            <div className='relative'>
                                <InputBoxWraper>
                                    <input
                                        type='text'
                                        className='w-full bg-transparent outline-none border-none pr-8'
                                        placeholder='Select Education'
                                        value={states.education}
                                        onChange={(e) => {
                                            setStates((prev) => ({
                                                ...prev,
                                                education: e.target.value
                                            }));

                                            setOpenDropdown('education');
                                        }}
                                        onFocus={() => {
                                            setOpenDropdown('education');
                                        }}
                                        name='education'
                                        autoComplete='off'
                                    />
                                </InputBoxWraper>

                                {/* Dropdown Arrow */}
                                <button
                                    type='button'
                                    onClick={() => {
                                        setOpenDropdown(
                                            openDropdown === 'education'
                                                ? null
                                                : 'education'
                                        );
                                    }}
                                    className='absolute right-2 top-1/2 -translate-y-1/2 w-8 h-8 flex items-center justify-center text-[#171717]'
                                >
                                    <svg
                                        className={`w-4 h-4 text-[#5A5A5A] transition-transform duration-200 ${
                                            openDropdown === 'education' ? 'rotate-180' : ''
                                        }`}
                                        viewBox='0 0 24 24'
                                        fill='none'
                                        xmlns='http://www.w3.org/2000/svg'
                                    >
                                        <path
                                            d='M6 9L12 15L18 9'
                                            stroke='currentColor'
                                            strokeWidth='2'
                                            strokeLinecap='round'
                                            strokeLinejoin='round'
                                        />
                                    </svg>
                                </button>

                                {/* Education Dropdown */}
                                {openDropdown === 'education' && (
                                    <div className='absolute z-50 top-[calc(100%+4px)] left-0 w-full max-h-52 overflow-y-auto bg-white border border-[#E1E1E1] rounded-lg shadow-lg'>

                                        {EDUCATION_LIST
                                            .filter((education) =>
                                                String(education)
                                                    .toLowerCase()
                                                    .includes(
                                                        states.education.toLowerCase()
                                                    )
                                            )
                                            .map((education, index) => (
                                                <button
                                                    type='button'
                                                    key={index}
                                                    onClick={() => {
                                                        setStates((prev) => ({
                                                            ...prev,
                                                            education: education
                                                        }));

                                                        setOpenDropdown(null);
                                                    }}
                                                    className='w-full text-left px-4 py-2.5 text-sm text-[#333] hover:bg-[#FFF3ED] hover:text-[#FF5D0E]'
                                                >
                                                    {education}
                                                </button>
                                            ))}

                                        {EDUCATION_LIST.filter((education) =>
                                            String(education)
                                                .toLowerCase()
                                                .includes(
                                                    states.education.toLowerCase()
                                                )
                                        ).length === 0 && (
                                            <div className='px-4 py-3 text-sm text-gray-500'>
                                                No education options found
                                            </div>
                                        )}

                                    </div>
                                )}
                            </div>

                            {formError?.education && (
                                <h6 className='text-primary-color-900 text-sm mt-1'>
                                    {formError.education}
                                </h6>
                            )}
                        </div>

                        <div>
                            <h4 className='text-sm font-semibold'>
                                Years of Experience*
                            </h4>

                            <InputBoxWraper>
                                <input
                                    type='number'
                                    min='0'
                                    step='1'
                                    className='w-full bg-transparent outline-none border-none'
                                    placeholder='e.g. 2'
                                    value={states.years_of_experience}
                                    onChange={handleChange}
                                    name='years_of_experience'
                                    required
                                />
                            </InputBoxWraper>

                            {formError?.years_of_experience && (
                                <h6 className='text-primary-color-900 text-sm mt-1'>
                                    {formError.years_of_experience}
                                </h6>
                            )}
                        </div>

                        <div className='flex gap-2'>

                            <div className='flex-1'>
                                <h4 className='text-sm font-semibold'>
                                    Current CTC*
                                </h4>

                                <InputBoxWraper>
                                    <input
                                        type='number'
                                        min='0'
                                        className='w-full bg-transparent outline-none border-none'
                                        placeholder='e.g. 500000'
                                        value={states.current_ctc}
                                        onChange={handleChange}
                                        name='current_ctc'
                                        required
                                    />
                                </InputBoxWraper>

                                {formError?.current_ctc && (
                                    <h6 className='text-primary-color-900 text-sm mt-1'>
                                        {formError.current_ctc}
                                    </h6>
                                )}
                            </div>

                            <div className='flex-1'>
                                <h4 className='text-sm font-semibold'>
                                    Expected CTC*
                                </h4>

                                <InputBoxWraper>
                                    <input
                                        type='number'
                                        min='0'
                                        className='w-full bg-transparent outline-none border-none'
                                        placeholder='e.g. 700000'
                                        value={states.expected_ctc}
                                        onChange={handleChange}
                                        name='expected_ctc'
                                        required
                                    />
                                </InputBoxWraper>

                                {formError?.expected_ctc && (
                                    <h6 className='text-primary-color-900 text-sm mt-1'>
                                        {formError.expected_ctc}
                                    </h6>
                                )}
                            </div>

                        </div>

                        <div>
                            <h4 className='text-sm font-semibold mb-1'>
                                Current City*
                            </h4>

                            <div className='relative'>
                                <InputBoxWraper>
                                    <input
                                        type='text'
                                        className='w-full bg-transparent outline-none border-none pr-8'
                                        placeholder='Select City'
                                        value={states.city}
                                        onChange={(e) => {
                                            setStates((prev) => ({
                                                ...prev,
                                                city: e.target.value
                                            }));

                                            setOpenDropdown('city');
                                        }}
                                        onFocus={() => {
                                            setOpenDropdown('city');
                                        }}
                                        name='city'
                                        autoComplete='off'
                                    />
                                </InputBoxWraper>

                                {/* Dropdown Arrow */}
                                <button
                                    type='button'
                                    onClick={() => {
                                        setOpenDropdown(
                                            openDropdown === 'city'
                                                ? null
                                                : 'city'
                                        );
                                    }}
                                    className='absolute right-2 top-1/2 -translate-y-1/2 w-8 h-8 flex items-center justify-center text-[#171717]'
                                >
                                    <svg
                                        className={`w-4 h-4 text-[#5A5A5A] transition-transform duration-200 ${
                                            openDropdown === 'city' ? 'rotate-180' : ''
                                        }`}
                                        viewBox='0 0 24 24'
                                        fill='none'
                                        xmlns='http://www.w3.org/2000/svg'
                                    >
                                        <path
                                            d='M6 9L12 15L18 9'
                                            stroke='currentColor'
                                            strokeWidth='2'
                                            strokeLinecap='round'
                                            strokeLinejoin='round'
                                        />
                                    </svg>
                                </button>

                                {/* City Dropdown */}
                                {openDropdown === 'city' && (
                                    <div className='absolute z-50 top-[calc(100%+4px)] left-0 w-full max-h-52 overflow-y-auto bg-white border border-[#E1E1E1] rounded-lg shadow-lg'>

                                        {CITY_LIST
                                            .filter((city) =>
                                                String(city)
                                                    .toLowerCase()
                                                    .includes(
                                                        states.city.toLowerCase()
                                                    )
                                            )
                                            .map((city, index) => (
                                                <button
                                                    type='button'
                                                    key={index}
                                                    onClick={() => {
                                                        setStates((prev) => ({
                                                            ...prev,
                                                            city: city
                                                        }));

                                                        setOpenDropdown(null);
                                                    }}
                                                    className='w-full text-left px-4 py-2.5 text-sm text-[#333] hover:bg-[#FFF3ED] hover:text-[#FF5D0E]'
                                                >
                                                    {city}
                                                </button>
                                            ))}

                                        {CITY_LIST.filter((city) =>
                                            String(city)
                                                .toLowerCase()
                                                .includes(
                                                    states.city.toLowerCase()
                                                )
                                        ).length === 0 && (
                                            <div className='px-4 py-3 text-sm text-gray-500'>
                                                No city options found
                                            </div>
                                        )}

                                    </div>
                                )}
                            </div>

                            {formError?.city && (
                                <h6 className='text-primary-color-900 text-sm mt-1'>
                                    {formError.city}
                                </h6>
                            )}
                        </div>
                        
                        <div>
                            <h4 className=' text-sm font-semibold'>Mobile number*</h4>
                            <InputBoxWraper>

                                <input
                                    type="number"
                                    className=" w-full bg-transparent outline-none border-none"
                                    placeholder={placeHolder.mobile}
                                    value={states.mobile}
                                    onChange={handleChange}
                                    name="mobile"
                                    required
                                />
                            </InputBoxWraper>
                            {formError?.mobile && <h6 className='text-primary-color-900 text-sm mt-1'>{formError.mobile}</h6>}
                        </div>
                        <div>
                            <h4 className=' text-sm font-semibold'>LinkedIn url</h4>
                            <InputBoxWraper>
                                <input
                                    type="text"
                                    className=" w-full bg-transparent outline-none border-none"
                                    placeholder={placeHolder.linkedin}
                                    value={states.linkedin}
                                    onChange={handleChange}
                                    name="linkedin"
                                    required
                                />
                            </InputBoxWraper>
                            {/* {formError?.linkedin && <h6 className='text-primary-color-900 text-sm mt-1'>{formError.linkedin}</h6>} */}
                        </div>
                        <button
                            onClick={handleSubmit}
                            className=' mx-auto w-fit bg-primary-color-900 text-white py-2 px-10 rounded-full  font-semibold hover:brightness-90 transition-all duration-300'>
                            Apply
                        </button>
                    </div>)}
            </div>
        </div>
    )
}

export default SmallSignUp;